import { useMutation } from 'react-query';
import deleteRoomAttachment from '../requests/deleteRoomAttachment';

const useDeleteRoomAttachmentMutation = (options) =>
  useMutation(
    ({ attachmentId, room }) => deleteRoomAttachment(attachmentId, room),
    options
  );

export default useDeleteRoomAttachmentMutation;
